(function() { window.GUID_e55c8979_a02a_4346_8f53_2e73ccfe7503 = { getGuid: function() { return "e55c8979-a02a-4346-8f53-2e73ccfe7503"; } }; })();
var Newsfeed;
(function (Newsfeed) {
    class NewsfeedPost {
        constructor($post) {
            this.readMore($post);
            $post.offon("click.newsfeed-post", function (e) {
                let $target = $(e.target);
                if ($target.is("a")) {
                    e.preventDefault();
                    if ($target.closest(".dropdown-content").length == 0) {
                        if ($target.closest(".jodit-container").length == 0) {
                            window.open($target.attr("href"), "_blank");
                        }
                    }
                }
            });
            // CONTENT :
            // - PhotoSwipe
            // - Read more
            // ===========================================================================================================|
            // ==========================================> PhotoSwipe
            // ===========================================================================================================|
            var initPhotoSwipeFromDOM = function (gallerySelector) {
                // Création d'une liste d'items contenant les données d'une "slide"
                var parseThumbnailElements = function (el) {
                    var thumbElements = el.childNodes, numNodes = thumbElements.length, items = [], container, thumbnail, item;
                    var $thumbnail;
                    for (let i = 0; i < numNodes; i++) {
                        container = thumbElements[i];
                        if (container.nodeType !== 1) {
                            continue;
                        }
                        if (container.children.length > 0) {
                            thumbnail = container.querySelectorAll("img")[0];
                            $thumbnail = $(container).find("img").first();
                        }
                        let imageURL = $thumbnail.attr("src"), advertisingURL = $thumbnail.data("advertising-url"), advertisingTitle = $thumbnail.data("advertising-title"), advertisingDescription = $thumbnail.data("advertising-description"), advertisingButtonCSRess = $("#visit-the-website-traduction").first().attr("value");
                        let customHTML = `<div class="pswp__ads-container">`;
                        if (advertisingTitle != "" && advertisingTitle != undefined) {
                            customHTML += `<div class="row">`
                                + `<div class="pswp__ads-title">${advertisingTitle}</div>`
                                + `</div>`;
                        }
                        if (advertisingURL != "" && advertisingURL != undefined) {
                            customHTML += `<div class="row">`
                                + `<img class="pswp__ads-image" src="${imageURL}" href="${advertisingURL}" target="_blank" alt="${advertisingTitle}" />`
                                + `</div>`;
                        }
                        else {
                            customHTML += `<div class="row">`
                                + `<img class="pswp__ads-image" src="${imageURL}" href="#" target="_self" alt="${advertisingTitle}" />`
                                + `</div>`;
                        }
                        if (advertisingDescription != "" && advertisingDescription != undefined) {
                            customHTML += `<div class="row">`
                                + `<div class="pswp__ads-description">${advertisingDescription}</div>`
                                + `</div>`;
                        }
                        if (advertisingURL != "" && advertisingURL != undefined) {
                            customHTML += `<div class="row">`
                                + `<button class="pswp__ads-button" href="${advertisingURL}">${advertisingButtonCSRess}</button>`
                                + `</div>`;
                        }
                        customHTML += `</div>`;
                        //Création d'une slide (item)
                        if ($thumbnail.hasClass("advertising")) {
                            item = {
                                html: customHTML,
                                advertising: true
                            };
                        }
                        else {
                            item = {
                                // Image originale
                                src: container.getAttribute('href'),
                                w: thumbnail.naturalWidth,
                                h: thumbnail.naturalHeight,
                                // Image thumbnail
                                msrc: thumbnail.getAttribute('src'),
                                // Titre à afficher ou non sur une slide
                                title: "",
                                // Lien vers le container de l'image
                                el: container,
                                advertising: false
                            };
                        }
                        items.push(item);
                    }
                    return items;
                };
                // Recherche du parent le plus près d'un élément "el"
                var closest = function closest(el, fn) {
                    return el && (fn(el) ? el : closest(el.parentNode, fn));
                };
                // Déclenchement lorsqu'un clique sur un élément thumbnail est détecté
                var onThumbnailsClick = function (e) {
                    e = e || window.event;
                    e.preventDefault ? e.preventDefault() : e.returnValue = false;
                    var eTarget = e.target || e.srcElement;
                    // Recherche de l'élément racine d'une slide par son tagname (le tag du contenur peut être différent, tant qu'il possède l'attribut "href")
                    var clickedListItem = closest(eTarget, function (el) {
                        return (el.tagName && el.tagName.toUpperCase() === 'DIV');
                    });
                    if (!clickedListItem) {
                        return;
                    }
                    // Recherche de l'index d'un élément cliqué via une boucle de tous les éléments enfants de son parent
                    var clickedGallery = clickedListItem.parentNode, childNodes = clickedListItem.parentNode.childNodes, numChildNodes = childNodes.length, nodeIndex = 0, index;
                    for (var i = 0; i < numChildNodes; i++) {
                        if (childNodes[i].nodeType !== 1) {
                            continue;
                        }
                        if (childNodes[i] === clickedListItem) {
                            index = nodeIndex;
                            break;
                        }
                        nodeIndex++;
                    }
                    // Ouverture de PhotoSwipe si un index valide est trouvé
                    if (index >= 0) {
                        openPhotoSwipe(index, clickedGallery, false, false);
                    }
                    return false;
                };
                // Analyse de l'index de l'image (pid) et de la gallerie (gid) depuis l'URL (#&pid=1&gid=2)
                var photoswipeParseHash = function () {
                    var hash = window.location.hash.substring(1), params = {};
                    if (hash.length < 5) {
                        return params;
                    }
                    var vars = hash.split('&');
                    for (var i = 0; i < vars.length; i++) {
                        if (!vars[i]) {
                            continue;
                        }
                        var pair = vars[i].split('=');
                        if (pair.length < 2) {
                            continue;
                        }
                        params[pair[0]] = pair[1];
                    }
                    if (params.gid) {
                        params.gid = parseInt(params.gid, 10);
                    }
                    return params;
                };
                // Ouverture de PhotoSwipe
                var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
                    // Sélection de l'élément racine de PhotoSwipe
                    var pswpElement = document.querySelectorAll('.pswp')[0], gallery, options, items;
                    // Création des items (slides)
                    items = parseThumbnailElements(galleryElement);
                    // Définition des options (facultatif)
                    //Options pour les publicités
                    if (items[0].advertising == true) {
                        options = {
                            showHideOpacity: true,
                            timetoIdle: 100000,
                            timeToIdleOutside: 100000,
                            shareEl: false,
                            // Définition de l'index de la gallerie (pour l'URL)
                            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
                        };
                    }
                    //Options pour les images "normales"
                    else {
                        options = {
                            showHideOpacity: true,
                            // Définition de l'index de la gallerie (pour l'URL)
                            galleryUID: galleryElement.getAttribute('data-pswp-uid'),
                            shareEl: false,
                            // Amination du thumbnail
                            getThumbBoundsFn: function (index) {
                                var thumbnail = items[index].el.getElementsByTagName('img')[0], // Recherche de l'élément
                                pageYScroll = window.pageYOffset || document.documentElement.scrollTop, rect = thumbnail.getBoundingClientRect();
                                // Potision de l'élément
                                return {
                                    x: rect.left,
                                    y: rect.top + pageYScroll,
                                    w: rect.width
                                };
                            }
                        };
                    }
                    // Ouverture de PhotoSwipe depuis un URL
                    if (fromURL === true) {
                        if (options.galleryPIDs) {
                            for (var j = 0; j < items.length; j++) {
                                if (items[j].pid == index) {
                                    options.index = j;
                                    break;
                                }
                            }
                        }
                        else {
                            // in URL indexes start from 1
                            options.index = parseInt(index, 10) - 1;
                        }
                    }
                    // Ouverture de PhotoSwipe depuis un évènement sur le DOM
                    else {
                        options.index = parseInt(index, 10);
                    }
                    // Si aucun index valide n'est trouvé, stop
                    if (isNaN(options.index)) {
                        return;
                    }
                    if (disableAnimation === true) {
                        options.showAnimationDuration = 0;
                    }
                    // Création d'une nouvelle instance de PhotoSwipe avec les données récoltées et l'initialiser
                    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                    gallery.init();
                };
                // Association des évènements à toutes les galleries dans le DOM
                var galleryElements = document.querySelectorAll(gallerySelector);
                for (var i = 0, l = galleryElements.length; i < l; i++) {
                    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
                    galleryElements[i].onclick = onThumbnailsClick;
                }
                // Analyse de l'URL et ouverture de la gallerie s'il contient #&pid=3&gid=1
                var hashData = photoswipeParseHash();
                if (hashData.pid && hashData.gid) {
                    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
                }
            };
            initPhotoSwipeFromDOM('.photo-swipe-gallery');
        }
        // ===========================================================================================================|
        // ==========================================> Read more
        // ===========================================================================================================|
        readMore($post) {
            let sections = $post.children(), maxHeight = 350, height = 0, contentIsHidden = false;
            //Calcul de la hauteur du post en excluant la gallerie et la section "édition"
            for (var i = 0; i < sections.length; i++) {
                let section = $(sections[i]);
                if (!section.hasClass("post-gallery") && !section.hasClass("post-edit") && !section.hasClass("Slider")) {
                    //S'il n'y a qu'un seul enfant de type "iframe" dans la div, on ne la prend pas en compte.
                    if (!(section.children().length == 1 && section.children().first().prop("tagName") == "IFRAME")) {
                        height += section.height();
                    }
                }
            }
            if (height > maxHeight + 50) {
                let $readMoreContent = $post.find(".post-message");
                //Ajout d'une section pour l'opacité graduelle dans le bas du post
                $readMoreContent.append(`<div class="opacity-gradient"></div>`);
                let $opacityGradient = $readMoreContent.find(".opacity-gradient").first();
                // Affichage de la section pour le bouton "read more"
                let $readMoreControl = $post.find(".read-more-control").first();
                $readMoreControl.css({
                    "display": "flex"
                });
                let $readMoreButton = $readMoreControl.find("button").first();
                //Limitation de la hauteur de la section du texte
                $readMoreContent.css({
                    "max-height": `${maxHeight}px`,
                    "overflow": "hidden",
                });
                contentIsHidden = true;
                $readMoreButton.click(function () {
                    if (contentIsHidden) {
                        contentIsHidden = false;
                        $readMoreContent.css({
                            "max-height": "none",
                            "overflow": "hidden",
                        });
                        $opacityGradient.css({
                            "display": "none"
                        });
                        $readMoreButton.off("click");
                        $readMoreButton.remove();
                        return;
                    }
                });
            }
        }
    }
    Newsfeed.NewsfeedPost = NewsfeedPost;
})(Newsfeed || (Newsfeed = {}));

//# sourceMappingURL=newsfeed-post.js.map
